import * as React from "react";
const SvgIconHome = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 18", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M18,17V9h2L10,0,0,9H2v8a.94.94,0,0,0,1,1H8V11h4v7h5A.94.94,0,0,0,18,17Z", fill: "currentColor" }));
export { SvgIconHome as ReactComponent };
